import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFontCssData, getFontData, postFonts, postUploadFonts, putFonts } from "../../helpers/backend_helper";
import { setFontNotFound, setFonts, setFontUploaded, setSelectedFonts } from "./reducer";
import { groupFontsByFamily } from "./helper";
import { toast } from "react-toastify";
import { toggleFontModal } from "../modals/reducer";
import { setFontNotUploaded, updateFontNotUploaded } from "../campaigns/reducer";
import { checkMaintenance } from "../auth/login/helper";
import config from "../../config";
import { getFontList } from "../campaigns/thunk";

export const getFontCss = createAsyncThunk('font/getFontCss', async (params, { dispatch, getState }) => {
  try {
    const { brandPath } = getState().MenuData;
    const response = await getFontCssData({ family: params, brandId: brandPath });
    // console.log(response);
    dispatch(setFonts([]));
    if (response) {
      return response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
});

export const getFonts = createAsyncThunk('font/getFonts', async (params, { dispatch, getState }) => {
  try {
    const { brandPath } = getState().MenuData;
    const response = await getFontData({ family: params, brandId: brandPath });
    if (response.data.length > 0) {
      dispatch(setFontNotFound(false));
      let responseData = response.data;
      return responseData;
    } else {
      dispatch(setFontNotFound(true));
      return [];
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
});

export const uploadFonts = (fontFamily) => async (dispatch, getState) => {
  try {
    const { client, clientPath, brandPath } = getState().MenuData
    const uploadedFonts = [];
    let i = 0;
    do {
      let response = await postUploadFonts({
        files: fontFamily[i].file,
        companyId: client._id,
        clientId: clientPath,
        brandId: brandPath
      });
      if (response.status === 'ok') {
        uploadedFonts.push(response.data[0]);
      }
      i++;
    } while (i < fontFamily.length);
    return uploadedFonts;
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
};

export const checkIsFontLoadedOnGoogle = (loadingFontName) => async (dispatch, getState) => {
  try {
    const { filteredFontList } = getState().Campaign;
    if (filteredFontList.length > 0) {
      const foundFont = filteredFontList.find(font => font.family === loadingFontName);
      if (foundFont && foundFont.hasOwnProperty('isGoogleFonts') && foundFont.isGoogleFonts) {
        toast.error(`The font ${loadingFontName} is already available on the system.`, { autoClose: 3000 });
        return true;
      }
    }
    return false;
  } catch (error) {
    // console.log(error);
  }
}

export const createFont = () => async (dispatch, getState) => {
  const { brandPath, language } = getState().MenuData;
  try {
    const { selectedFonts } = getState().Font;
    let response;
    if (selectedFonts.length > 0) {
      const groupedFonts = groupFontsByFamily(selectedFonts);
      let i = 0;
      do {
        const isFontLoadedGoogle = dispatch(checkIsFontLoadedOnGoogle(groupedFonts[i][0].family));
        if (!isFontLoadedGoogle) {
          const loadedFonts = await dispatch(uploadFonts(groupedFonts[i]));
          if (loadedFonts) {
            let body = [];
            let k = 0;
            do {
              body.push({
                family: groupedFonts[i][k].family,
                weight: String(groupedFonts[i][k].weight),
                format: loadedFonts[k][0].format,
                brandId: brandPath,
                style: groupedFonts[i][k].style,
                src: loadedFonts[k][0].src
              });
              k++;
            } while (k < loadedFonts.length);
            response = await postFonts([...body]);
            if (response.status === 'err') {
              toast.error(language[response?.status], { autoClose: 3000 });
            }
          }
        }
        i++;
      } while (i < groupedFonts.length);
    } else {
      return;
    }
    toast.success(language[response?.status], { autoClose: 3000 });
    dispatch(checkFontsAfterUpload(selectedFonts));
    dispatch(toggleFontModal());
    dispatch(setSelectedFonts([]));
    dispatch(setFonts([]));
    await dispatch(getFontList());
    dispatch(setFontUploaded(false));
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const updateFont = (mainFontId) => async (dispatch, getState) => {
  const { brandPath, language } = getState().MenuData;
  try {
    const { selectedFonts } = getState().Font;
    let response;
    if (selectedFonts.length > 0) {
      const groupedFonts = groupFontsByFamily(selectedFonts);
      let i = 0;
      do {
        const isFontLoadedGoogle = dispatch(checkIsFontLoadedOnGoogle(groupedFonts[i][0].family));
        if (!isFontLoadedGoogle) {
          const loadedFonts = await dispatch(uploadFonts(groupedFonts[i]));
          if (loadedFonts) {
            let body = [];
            let k = 0;
            do {
              body.push({
                family: groupedFonts[i][k].family,
                weight: String(groupedFonts[i][k].weight),
                format: groupedFonts[i][k].format,
                brandId: brandPath,
                style: groupedFonts[i][k].style,
                src: loadedFonts[k][0].src
              });
              k++;
            } while (k < loadedFonts.length);
            response = await putFonts({ mainFontId: mainFontId, fontsArray: [...body] });
            if (response.status === 'err') {
              toast.error(language[response?.status], { autoClose: 3000 });
            }
          }
        }
        i++;
      } while (i < groupedFonts.length);
    } else {
      return;
    }
    toast.success(language[response?.status], { autoClose: 3000 });
    dispatch(checkFontsAfterUpload(selectedFonts));
    dispatch(toggleFontModal());
    dispatch(setSelectedFonts([]));
    dispatch(setFonts([]));
    await dispatch(getFontList());
    dispatch(setFontUploaded(false));
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const handleFonts = () => async (dispatch, getState) => {
  const { brandPath, language } = getState().MenuData;
  try {
    const { selectedFonts } = getState().Font;
    const { filteredFontList } = getState().Campaign;

    let response;
    if (selectedFonts.length > 0) {
      const groupedFonts = groupFontsByFamily(selectedFonts);
      let i = 0;
      do {
        const foundFont = filteredFontList.find(font => font.family === groupedFonts[i][0].family);
        if (foundFont && foundFont.hasOwnProperty('isGoogleFonts') && foundFont.isGoogleFonts) {
          toast.error(`The font ${groupedFonts[i][0].family} is already available on the system.`, { autoClose: 3000 });
        } else {
          const loadedFonts = await dispatch(uploadFonts(groupedFonts[i]));
          if (loadedFonts && loadedFonts.length > 0) {
            let body = [];
            let k = 0;
            do {
              body.push({
                family: groupedFonts[i][k].family,
                weight: String(groupedFonts[i][k].weight),
                format: groupedFonts[i][k].format,
                brandId: brandPath,
                style: groupedFonts[i][k].style,
                src: loadedFonts[k][0].src
              });
              k++;
            } while (k < loadedFonts.length);
            if (foundFont) {
              // Update
              response = await putFonts({ mainFontId: foundFont._id, fontsArray: [...body] });
              if (response.status === 'err') {
                toast.error(language[response?.status], { autoClose: 3000 });
              }
            } else {
              // Create
              response = await postFonts([...body]);
              if (response.status === 'err') {
                toast.error(language[response?.status], { autoClose: 3000 });
              }
            }
          }
        }
        i++;
      } while (i < groupedFonts.length);
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const checkCreativeFont = (creativeObj) => async (dispatch, getState) => {
  try {
    const { brandPath } = getState().MenuData;
    const { filteredFontList, fontNotUploadedName } = getState().Campaign;
    const fonts = creativeObj.node.frame.fonts.split('||');
    if (fonts.length > 0) {
      let i = 0;
      do {
        const fi = fonts[i].split(':');
        const fontName = fi[0];
        const fontStyle = fi[1];
        const fontWeight = fi[2];
        if (fontName && fontStyle && fontWeight) {
          const foundFont = filteredFontList.find(font => font.family === fontName);
          let res;
          if (foundFont) {
            if (foundFont.hasOwnProperty('isGoogleFonts') && foundFont.isGoogleFonts) {
              let fontQueryText = `https://fonts.googleapis.com/css2?family=${fontName}:wght@${fontWeight}&display=swap&key=${config.googleFontKey}`;
              if (fontStyle == 'italic') {
                fontQueryText = `https://fonts.googleapis.com/css2?family=${fontName}:ital,wght@1,${fontWeight}&display=swap&key=${config.googleFontKey}`;
              }
              res = await fetch(fontQueryText);
              res = await res.text();
            } else {
              res = await getFontCssData({ family: fontName, weight: fontWeight, style: fontStyle, brandId: brandPath });
            }
          }

          if (typeof res !== 'string') {
            const notUploadedFont = `${fontName} - ${fontStyle} - ${fontWeight}`;
            dispatch(setFontNotUploaded({ fontNotUploadedName: notUploadedFont, fontNotUploaded: true }));
            if (window.scrollY >= 180 && !fontNotUploadedName.includes(notUploadedFont)) {
              toast.error(`The fonts ${fontName} - ${fontStyle} - ${fontWeight} used in your creative set is not available in our system. This may cause your creatives to display with an incorrect font. Please select a different font or upload the required font to ensure accurate display.`);
            }
          }
        }
        i++;
      } while (i < fonts.length);
    }
  } catch (error) {

  }
}

export const checkFontsAfterUpload = (selectedFonts) => async (dispatch, getState) => {
  try {
    if (selectedFonts.length > 0) {
      let i = 0;
      do {
        const font = selectedFonts[i];
        dispatch(updateFontNotUploaded(`${font.family} - ${font.style} - ${font.weight}`));
        i++;
      } while (i < selectedFonts.length);
    }
  } catch (error) {

  }
}

export const loadFonts = (figmaObj) => async (dispatch, getState) => {
  try {
    const { brandPath } = getState().MenuData;
    const { filteredFontList, fontNotUploadedName } = getState().Campaign;
    let finalFontsStr = ``;
    let fonts = figmaObj.node.frame.fonts.split('||');
    if (fonts.length > 0 && filteredFontList.length > 0) {
      let i = 0;
      do {
        const fi = fonts[i].split(':');
        const fontName = fi[0];
        const fontStyle = fi[1];
        const fontWeight = fi[2];
        const foundFont = filteredFontList.find(font => font.family === fontName);
        if (foundFont) {
          let res;
          if (foundFont.hasOwnProperty('isGoogleFonts') && foundFont.isGoogleFonts) {
            let fontQueryText = `https://fonts.googleapis.com/css2?family=${fontName}:wght@${fontWeight}&display=swap&key=${config.googleFontKey}`;
            if (fontStyle == 'italic') {
              fontQueryText = `https://fonts.googleapis.com/css2?family=${fontName}:ital,wght@1,${fontWeight}&display=swap&key=${config.googleFontKey}`;
            }
            try {
              res = await fetch(fontQueryText);
              res = await res.text();
            } catch (e) {
              res = '';
              // console.log(e);
            }
          } else {
            try {
              res = await getFontCssData({ family: fontName, weight: fontWeight, style: fontStyle, brandId: brandPath });
            } catch (e) {
              // console.log(e);
            }
          }
          if (typeof res === 'string') {
            finalFontsStr += res;
          } else if (typeof res !== 'string') {
            const notUploadedFont = `${fontName} - ${fontStyle} - ${fontWeight}`;
            dispatch(setFontNotUploaded({ fontNotUploadedName: notUploadedFont, fontNotUploaded: true }));
            if (window.scrollY >= 180 && !fontNotUploadedName.includes(notUploadedFont)) {
              toast.error(`The fonts ${fontName} - ${fontStyle} - ${fontWeight} used in your creative set is not available in our system. This may cause your creatives to display with an incorrect font. Please select a different font or upload the required font to ensure accurate display.`);
            }
          }
        }
        i++;
      } while (i < fonts.length);
    }
    return finalFontsStr;
  } catch (error) {
  }
}